export default __webpack_public_path__ + "static/media/autocomplete-enter.3a2e20cb.svg";